{
  "LOGIN": {
    "TITLE": "Entrar no centro de contacto",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Empresa{'@'}suaempresa.com.br",
      "ERROR": "Por favor, insira um endereço de e-mail válido"
    },
    "PASSWORD": {
      "LABEL": "Palavra-passe",
      "PLACEHOLDER": "Palavra-passe"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login bem-sucedido",
      "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot. Por favor, tente novamente.",
      "UNAUTH": "E-mail ou palavra-passe incorretos. Por favor, tente novamente.",
      "ACCOUNT_DEACTIVATED": "A sua conta foi desativada. Contacte o seu administrador.",
      "PASSWORD_LOGIN_DISABLED": "O início de sessão com palavra-passe está desativado para a sua conta. Inicie sessão através de OAuth (por exemplo, Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Iniciar sessão com o Google",
      "BUSINESS_ACCOUNTS_ONLY": "Por favor, use o endereço de e-mail da empresa para iniciar sessão",
      "NO_ACCOUNT_FOUND": "Não conseguimos encontrar uma conta com o seu endereço de e-mail."
    },
    "FORGOT_PASSWORD": "Esqueceu-se da sua palavra-passe?",
    "CREATE_NEW_ACCOUNT": "Criar nova conta",
    "SUBMIT": "Iniciar sessão"
  }
}
